import Button from './ui/Button'
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const PdfViewer = ({ file, showSmall, pageNumber, setPageNumber, numPages, setNumPages }) => {
    const [dimensions, setDimensions] = useState({
        width: showSmall ? 400 : window.innerWidth,
        height: showSmall ? 400 : window.innerHeight,
    });
    const [loadError, setLoadError] = useState(false)

    useEffect(() => {
        if (!showSmall) {
            const handleResize = () => {
                setDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        setLoadError(false)
    }, [file])

    const onDocumentLoadSuccess = ({ numPages }) => {
        setLoadError(false)
        if (setNumPages) {

            setNumPages(numPages);
            setPageNumber(1);
        }
    };

    const goToPrevPage = () =>
        setPageNumber((prev) => (prev > 1 ? prev - 1 : prev));

    const goToNextPage = () =>
        setPageNumber((prev) => (prev < numPages ? prev + 1 : prev));

    if (loadError) {
        return (
            <div style={{ width: showSmall ? 300 : '100%', maxWidth: 1200 }}>
                <iframe
                    title="PDF preview"
                    src={file}
                    style={{
                        width: '100%',
                        height: showSmall ? 360 : Math.max(480, dimensions.height - 120),
                        border: '1px solid #e2e8f0',
                        borderRadius: 8,
                        backgroundColor: '#fff',
                    }}
                />
                <div style={{ marginTop: 8, textAlign: 'center', fontSize: 13 }}>
                    <a href={file} target="_blank" rel="noreferrer">Open PDF</a>
                </div>
            </div>
        )
    }

    return (
        <div style={{ justifyContent: "center", display: 'flex', flexDirection: 'column', alignItems: 'center', alignSelf: 'center' }}>
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess} onLoadError={() => setLoadError(true)}>
                <Page
                    pageNumber={pageNumber}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    width={Math.min(dimensions.width - 60, 1200)} // adjust for responsiveness
                    height={dimensions.height - 100}
                />
            </Document>
            <div style={{ marginTop: "10px", marginBottom: '50px' }}>
                <Button variant="secondary" size="md" onClick={goToPrevPage}  disabled={pageNumber <= 1}>
                    ◀ Back
                </Button>
                <span style={{ margin: "0 15px" }}>
                    Page {pageNumber} of {numPages}
                </span>
                <Button variant="secondary" size="md" onClick={goToNextPage}  disabled={pageNumber >= numPages}>
                    Next ▶
                </Button>
            </div>
        </div>
    );
};

export default PdfViewer;
